<template>
  <v-col :cols="cols">
    <v-card>
      <v-card-title
        :style="`padding: 6px 16px;border-top-width: 4px;border-top-color: ${$vuetify.theme.themes.light[color]};border-top-style: solid;`"
      >{{title}}</v-card-title>
      <v-divider></v-divider>
      <slot></slot>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          v-for="(btn , i) in actions"
          :key="`MAKJUST-USERBOX-BTN_${i}`"
          :color="btn.color ? btn.color : 'primary'"
          :to="btn.to"
          :append="btn.append ? btn.append : false"
          :dark="btn.dark ? btn.dark : false"
          :disabled="btn.disabled"
        >{{btn.content}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-col>
</template>

<script>
export default {
  name: "UBC",
  data() {
    return {};
  },
  props: {
    cols: Number,
    title: String,
    actions: Array,
    color: {
      type: String,
      default: 'primary'
    },
  }
};
</script>